import { createFileRoute } from "@tanstack/react-router";
import { LogViewer } from "~/app/(new)/admin/logs/LogViewer";

export const Route = createFileRoute("/_authed/admin/logs")({
  component: AdminLogsPage,
});

function AdminLogsPage() {
  return (
    <div className="h-full w-full">
      <LogViewer />
    </div>
  );
}
